module.exports = __webpack_public_path__ + "img/1.fbbd7d6d.jpg";